import { render } from "./UserCostListPage.vue?vue&type=template&id=8e847526&scoped=true"
import script from "./UserCostListPage.vue?vue&type=script&lang=js"
export * from "./UserCostListPage.vue?vue&type=script&lang=js"

import "./UserCostListPage.vue?vue&type=style&index=0&id=8e847526&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e847526"]])

export default __exports__